import { useEffect } from "react";
import "../Styles/voice.css";
import { useNavigate } from "react-router-dom";



function Voice() {
   const navigate = useNavigate();
    useEffect(() => {
    document.title = "Voice Of Employee | Outstanding Workplaces";
  }, []);
  return (
    <>
      {/* ==============================
         SECTION 1 — VOICE
      ============================== */}
      <section className="voice">

        <div className="voice-left">
          <h1 className="voice-title">
            Elevate Your Workplace Culture with <br />
            a Powerful Employee Voice.
          </h1>

          <p className="voice-desc">
            Elevate your workplace culture by truly listening to your employees.
            A powerful employee voice helps uncover real insights, strengthen
            engagement, and drive meaningful change creating a more connected,
            motivated, and high-performing organization.
          </p>

          <button
  className="voice-btn"
  type="button"
  onClick={() => {
    navigate('/nominate');
    window.scrollTo(0, 0);
  }}
>
  <img
    src="/assets/badge_get_certificate.png"
    alt="badge"
    className="voice-icon"
  />
  Get Certificate
</button>
        </div>

        <div className="voice-right">
         <img src="/assets/voice_image_01.png" alt="team" />
        </div>

      </section>


      {/* ==============================
         SECTION 2 — VOICE STEPS
      ============================== */}
      <section className="voice-steps">

        <h2 className="voice-steps-title">
          Capture employee voices and convert insights into action
        </h2>

        {/* STEP 1 */}
        <div className="voice-step">
          <div className="voice-step-content">
            <div className="voice-step-number">01</div>
            <h3 className="voice-step-heading">
              Turn employee feedback into meaningful workplace improvements
            </h3>
            <ul>
              <li>Employee feedback is a powerful tool for shaping a better workplace. By actively listening to your people, you gain valuable insights into what truly matters to them.</li>
              <li>These insights help you identify gaps, address challenges, and create strategies that enhance engagement, satisfaction, and productivity.</li>
              <li>When feedback is turned into action, it builds trust, strengthens culture, and drives continuous improvement across the organization.</li>
            </ul>
          </div>
          <div className="voice-step-image">
           <img src="/assets/voice_image_02.png" alt="step1" />
          </div>
        </div>

        {/* STEP 2 */}
        <div className="voice-step reverse">
          <div className="voice-step-content">
            <div className="voice-step-number">02</div>
            <h3 className="voice-step-heading">
              Gain real-time insights to strengthen engagement and retention
            </h3>
            <ul>
              <li>Gain real-time insights into employee sentiment and workplace experiences as they evolve. This enables organizations to respond quickly to concerns and opportunities, rather than relying on outdated feedback.</li>
              <li>By understanding what drives engagement, you can take targeted actions that improve satisfaction, boost morale, and reduce employee turnover. Data-driven decisions lead to stronger, more connected teams</li>
              <li>With continuous feedback at your fingertips, you can build a proactive culture that prioritizes employee well-being, enhances performance, and supports long-term retention.</li>
            </ul>
          </div>
          <div className="voice-step-image">
           <img src="/assets/voice_image_03.png" alt="step2" />
          </div>
        </div>

        {/* STEP 3 */}
        <div className="voice-step">
          <div className="voice-step-content">
            <div className="voice-step-number">03</div>
            <h3 className="voice-step-heading">
              Identify key drivers of employee satisfaction and performance
            </h3>
            <ul>
              <li>Understanding what truly drives employee satisfaction and performance is key to building a thriving workplace. By gathering the right insights, organizations can uncover what motivates their people and where improvements are needed.</li>
              <li>With clear visibility into these drivers, leaders can make informed decisions that enhance engagement, productivity, and overall employee experience. It helps prioritize actions that create meaningful impact.</li>
              <li>When organizations focus on what matters most to employees, they foster a positive culture, improve retention, and drive sustainable business success.</li>
            </ul>
          </div>
          <div className="voice-step-image">
            <img src="/assets/voice_image_04.png" alt="step3" />
          </div>
        </div>

        {/* STEP 4 */}
        <div className="voice-step reverse">
          <div className="voice-step-content">
            <div className="voice-step-number">04</div>
            <h3 className="voice-step-heading">
              Benchmark your organization against industry standards
            </h3>
            <ul>
              <li>Benchmark your organization against industry standards to understand where you truly stand. Gain clear visibility into your strengths and uncover areas that need improvement.</li>
              <li>Compare your employee experience metrics with top-performing organizations and identify meaningful gaps. Use these insights to align your strategies with proven best practices.</li>
              <li>Make informed, data-driven decisions that enhance performance, boost engagement, and position your organization as a leader in workplace excellence.</li>
            </ul>
          </div>
          <div className="voice-step-image">
            <img src="/assets/voice_image_05.png" alt="step4" />
          </div>
        </div>

        {/* STEP 5 */}
        <div className="voice-step">
          <div className="voice-step-content">
            <div className="voice-step-number">05</div>
            <h3 className="voice-step-heading">
              Deploy quick, seamless surveys with maximum impact
            </h3>
            <ul>
              <li>Deploy quick and seamless surveys that are easy to launch and effortless for employees to complete. With a streamlined process, you can gather valuable feedback without disrupting daily workflows.</li>
              <li>Our intuitive platform ensures faster participation and higher response rates, helping you capture accurate and meaningful insights in real time.</li>
              <li>Turn those insights into impactful actions that enhance employee experience, strengthen engagement, and drive continuous improvement across your organization.</li>
            </ul>
          </div>
          <div className="voice-step-image">
            <img src="/assets/voice_image_06.png" alt="step5" />
          </div>
        </div>

      </section>
    </>
  );
}

export default Voice;

